import React from "react";
import Decision from "../components/Decision/Decision";
import { useEffect, useState } from 'react';
import "../App.css";
import DebugTree from "../components/DebugTree"

const DecisionPage = () => {
    // const [decisionData, setDecisionData] = useState({});
    //     const [loading, setLoading] = useState(true);
    //     useEffect(() => {
    //         const url = "/api/data";
    //         //const url="https://www.planspiel-bw.de/dein-start-up/planspiel?getjson=1"
    
    //         fetch(url)
    //             .then(res => res.json())
    //             .then(data => {
    //                 setDecisionData(data);
    //                 setLoading(false);
    //             });
    //     }, [])
    

    return (
        <div>
            <DebugTree />
            <Decision />
        </div>
    )
}

export default DecisionPage;